<ion-header>
  <div class="modal-header">
    <ion-toolbar>
      <div class="modal-title">
        <h3>Select a {{ externalCrmType }} account</h3>
      </div>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="dismiss()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>
  <div class="flex-space-between flexed-align-center">
    <ion-searchbar
      #searchBar
      mode="ios"
      class="search-bar"
      placeholder="Find a {{ externalCrmType }} account..."
      showCancelButton="never"
      [(ngModel)]="searchText"
      (ionChange)="handleFilters()"
    ></ion-searchbar>
  </div>
</ion-header>

<ion-content>
  <ion-list class="no-padding transparent-bg">
    <ion-item
      *ngFor="let externalCrmAccount of externalCrmAccounts"
      (click)="selectExternalCrmAccount(externalCrmAccount)"
      button="true"
    >
      {{ externalCrmAccount.name }}
      <ion-icon
        name="checkmark"
        slot="end"
        *ngIf="selectedExternalCrmAccountId === externalCrmAccount.id"
      ></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>
